import styles from './Home.module.css';
import Section01 from '../components/Home/Section01';
import Section02 from '../components/Home/Section02';
import Section03 from '../components/Home/Section03';
import Section04 from '../components/Home/Section04';
import Section05 from '../components/Home/Section05';

function Home() {
  return (
    <div className={styles.home}>
      <div className={styles.homeContent}>
        <Section01 />
        <Section02 />
        <Section03 />
        <Section04 />
        <Section05 />
      </div>
    </div>
  );
}

export default Home;